import { render } from "./SystemBar.vue?vue&type=template&id=2b88fa06"
import script from "./SystemBar.vue?vue&type=script&lang=js"
export * from "./SystemBar.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\mvillegas\\Desktop\\coonfia-web\\repo-coonfia-web\\coonfia-mantenedor\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__